module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.request
    }
  }), _vm._v(" "), _c('v-alert', {
    staticClass: "mt-0",
    attrs: {
      "value": true,
      "type": "info"
    }
  }, [_c('strong', [_vm._v("Note")]), _vm._v("\n    Automations (like automatically adding codes and invoice details) do not run for\n    cloned appointments\n    "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "dark": ""
    }
  }, [_vm._v("Learn more "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), (_vm.appointment) ? _c('v-list', {
    staticClass: "ma-0 pa-0 grey lighten-4"
  }, [_c('appointment-list-item', {
    attrs: {
      "with-color-coding": false,
      "with-action": false,
      "appointment": _vm.appointment
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.window === _vm.WINDOWS.CLIENT_CLONE || _vm.window === _vm.WINDOWS.DATE_CLONE) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v("\n      Back\n    ")], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0 mt-4",
    attrs: {
      "label": "Add reminders"
    },
    model: {
      value: (_vm.withReminders),
      callback: function($$v) {
        _vm.withReminders = $$v
      },
      expression: "withReminders"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0 mt-4",
    attrs: {
      "label": "Copy codes"
    },
    model: {
      value: (_vm.copyCodes),
      callback: function($$v) {
        _vm.copyCodes = $$v
      },
      expression: "copyCodes"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.selected.length === 0 && _vm.selectedRelationshipsList.length === 0,
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Create " + _vm._s(_vm.selected.length || _vm.selectedRelationshipsList.length) + " appointments")])], 1) : _vm._e(), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-layout', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10 ma-4",
    on: {
      "click": function($event) {
        _vm.window = _vm.WINDOWS.CLIENT_CLONE
      }
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              Clone by client\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n              Copy all the information on this appointment across onto different clients\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Clone by client")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10 ma-4",
    on: {
      "click": function($event) {
        _vm.window = _vm.WINDOWS.DATE_CLONE
      }
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              Clone by date\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n              Create copies of this appointment for different dates\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Clone by date")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('client-list', {
    staticClass: "pt-2 pl-4",
    attrs: {
      "clear-on-select": false
    },
    on: {
      "relationshipselected": _vm.relationshipselected
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-list', {
    staticClass: "ma-3"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n              Copy this appointment to these clients:\n            ")]), _vm._v(" "), _vm._l((_vm.selectedRelationshipsList), function(rel) {
    return _c('client-list-item', {
      key: rel.id,
      attrs: {
        "client": rel.client,
        "relationship-id": rel.id,
        "with-action": false
      }
    }, [_c('v-list-tile-action', {
      attrs: {
        "slot": "actions"
      },
      slot: "actions"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeRelationship(rel)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)
  }), _vm._v(" "), (_vm.selectedRelationshipsList.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("No clients selected")])], 1)], 1) : _vm._e()], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs-4": ""
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('v-date-picker', {
      key: month,
      staticClass: "elevation-0 py-0 my-0",
      attrs: {
        "no-title": "",
        "multiple": "",
        "show-current": "",
        "allowed-dates": _vm.isAllowed,
        "scrollable": false,
        "prev-icon": "",
        "next-icon": "",
        "events": _vm.events,
        "disabled-dates": _vm.events,
        "picker-date": month
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-flex', {
    attrs: {
      "xs-12": "",
      "sm4": "",
      "offset-sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "text-center justify-center mt-5 elevation-10"
  }, [_c('v-card-title', {
    staticClass: "subheading justify-center"
  }, [_c('v-icon', {
    attrs: {
      "size": 42,
      "color": "success"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading justify-center"
  }, [_vm._v("\n            Successfully created " + _vm._s(_vm.clones.length) + " clones\n          ")]), _vm._v(" "), _c('v-list', [_vm._l((_vm.clones), function(appt) {
    return [_c('appointment-list-item', {
      key: appt.id,
      attrs: {
        "with-action": false,
        "appointment": appt
      }
    })]
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41815383","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/actions/CloneAppointment.vue
// module id = 1403
// module chunks = 9